import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';

type Props = {
  handleCancel: () => void;
  deleteRow: () => void;
  successBtnLable?: string;
  open?: boolean;
};
const DialogDelete = ({
  handleCancel,
  deleteRow,
  successBtnLable = 'Yes, Delete',
  open = true,
}: Props) => {
  return (
    <Dialog
      maxWidth='sm'
      fullWidth
      open={open}
      className='flex items-center justify-center'>
      <DialogContent className='text-center m-3'>
        <Box className='flex items-center justify-center'>
          <Typography variant='body2' className='font-bold text-16 mb-8'>
            Are you sure to perform this action?
          </Typography>
        </Box>
        <DialogActions className='p-0'>
          <Button variant='outlined' onClick={handleCancel} color='info'>
            No, Cancel
          </Button>
          <Button variant='contained' onClick={deleteRow}>
            {successBtnLable}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default DialogDelete;
